import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import Button from '../../../buttons/Button';
import PrinterNumberField from '../../../inputs/PrinterNumberField';

import { MOBILE_PRINTER_NUMBER, PRINTER_NUMBER_MAX_LENGTH } from '../../../../constants';
import styles from './MobilePrinter.css';

const useStyles = makeStyles({
  mobilePrinterRoot: {
    '@media (min-width:500px)': {
      width: '100%',
    },
  },
});

const MobilePrinter = () => {
  const { t } = useTranslation();
  const translationRoot = 'MOBILE_PRINTER';
  const [printerNumber, setPrinterNumber] = useState(() => localStorage.getItem(MOBILE_PRINTER_NUMBER) || '');
  const [isPrinterConnected, setIsPrinterConnected] = useState(() => !!localStorage.getItem(MOBILE_PRINTER_NUMBER));
  const [printerNumberError, setPrinterNumberError] = useState<boolean>(false);
  const classes = useStyles();

  const handlePrinterNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value.replace(/[^0-9]/g, '').slice(0, PRINTER_NUMBER_MAX_LENGTH);
    setPrinterNumber(inputValue);
    if (inputValue && printerNumberError) {
      setPrinterNumberError(false);
    }
  };

  const handlePrinterConnectionToggle = () => {
    if (isPrinterConnected) {
      setPrinterNumber('');
      setIsPrinterConnected(false);
      localStorage.setItem(MOBILE_PRINTER_NUMBER, '');
    } else if (printerNumber.trim() === '') {
      setPrinterNumberError(true);
    } else {
      setIsPrinterConnected(true);
      localStorage.setItem(MOBILE_PRINTER_NUMBER, printerNumber);
    }
  };

  return (
    <div className={styles.mainContent}>
      <h2>{t(`${translationRoot}.SELECT_PRINTER`)}</h2>
      {!isPrinterConnected ? (
        <div className={styles.printerNumberInput}>
          <div className={styles.printerInputLabel}>{t(`${translationRoot}.MOBILE_PRINTER_NUMBER`)}</div>
          <PrinterNumberField
            id="printerNumber"
            label={t(`${translationRoot}.PRINTER`)}
            value={printerNumber}
            onChange={handlePrinterNumberChange}
            error={printerNumberError}
            maxLength={PRINTER_NUMBER_MAX_LENGTH}
            inputRootClass={classes.mobilePrinterRoot}
          />
          {printerNumberError && (
            <div id="printer-number-error" className={styles.errorText}>
              {t(`${translationRoot}.MOBILE_PRINTER_NUMBER`)}
            </div>
          )}
        </div>
      ) : (
        <div>
          {t(`${translationRoot}.CONNECTED_TO`)} <span className={styles.boldText}>{printerNumber}</span>
        </div>
      )}

      <div className={styles.paginationContainer}>
        <Button className={styles.footerButton} onClick={handlePrinterConnectionToggle}>
          {t(`${translationRoot}.${isPrinterConnected ? 'DISCONNECT' : 'CONNECT'}`)}
        </Button>
      </div>
    </div>
  );
};

export default MobilePrinter;
